export const SOCIAL_ADVOCACY_NAVIGATION_SCOPE = 'social-advocacy';
